export const languages = {
    JAVASCRIPT: "JavaScript",
    CSHARP: "C#",
    SQL: "sql"
}

export const programmingExtras = {
    REACT: "ReactJS",
    NODE: "NodeJS",
    ASP: "ASP.net",
    DOTNET: ".net",
    DOTNETCORE: ".net core",
    AZURE: "Azure",
    MSSQL: "mssql"
}